import React, { useEffect, useState } from "react";
import DesktopMenu from "../../../common/DesktopMenu/index";
import MobileMenu from "../../../common/MobileMenu/index";
import useWindowSize from "../../../common/windowSize";
import NewFooter from "../../../common/NewFooter";
import BackButton from "../../Products/BackButton";
import { useNavigate } from "react-router-dom";
import { settingsList } from "../../../common/settingItemList";
import { useTranslation } from "react-i18next";
import { 
  Background, 
} from "../../../common/Faq/styles";
import {
  SettingsHeader,
  Title
} from '../styles';
import {
  SettingsButton,
  SettingsButtonWrapper,
  IconImage,
  SettingsSpan
} from './styles';

const Settings = () => {
  const navigate = useNavigate();
  const size = useWindowSize();
  const { t } = useTranslation();
  const [mobileMenu, setMobileMenu] = useState(false);

  // const response = await privateAPI.get(`/auth/bacchus/client/cart/order/${userID}?page_number=1&size_number=10`);
  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <React.Fragment>
      {mobileMenu ? <MobileMenu single={true}/> : <DesktopMenu single={true}/> }
      <Background marginTop adminPanel>
        <SettingsHeader>
          <BackButton userPanel/>
          <Title>
            {t("settings")}
          </Title>
        </SettingsHeader>
        <SettingsButtonWrapper>
          {settingsList.map(setting => 
            <SettingsButton key={setting.id} onClick={() => navigate(setting.route)}>
              <IconImage src={setting.icon}/>
              <SettingsSpan>{t(setting.name)}</SettingsSpan>
            </SettingsButton>
          )}
        </SettingsButtonWrapper>
      </Background>
      <NewFooter />
    </React.Fragment>
  );
};

export default Settings;
